import React from 'react';
import elephant from './elephant.svg';
import './App.css';



function App() {
  return (
      <div className="App">

            <div className="elephantContainer">

                <img src={elephant} className="elephant" alt="logo" />

            </div>

          <p className="help">Helping you to never forget</p>
          <p className="soon">Coming soon</p>


      </div>
  );
}

export default App;
